<template>
  <div class="footer-intro">
    <ul class="footer-intro__links">
      <li
        v-for="(link, index) in links"
        :key="`link-${index}`"
        class="footer-intro__link"
        @click="$emit('navigation', link)"
      >
        <FooterLink
          v-if="typeof link.checkVisibility === 'undefined' || link.checkVisibility()"
          class="footer-intro__anchor"
          :href="`https://${link.domain}${link.path}`"
          :text="link.text"
          :isSpa="isSpa && link.isSpa"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  CLASSICS_PAGE_PATH,
  CYCLON_PATH,
  WWW_SUBDOMAIN,
  FILTER_PAGE_BESTSELLERS_PATH,
  FILTER_PAGE_NEW_ARRIVALS_PATH,
  FRIENDBUY_PATH,
  PDP_GIFT_CARDS_PATH,
  ROGER_PATH,
  SHOE_FINDER_PATH,
} from '@/config/constants'
import { checkForApacCountry } from '@/config/constants/countries'
import FooterLink from '@/components/Footer/FooterLink.vue'

export default {
  name: 'FooterIntro',
  components: { FooterLink },

  data() {
    return {
      links: {
        newArrivals: {
          text: this.$t('new_arrivals'),
          domain: WWW_SUBDOMAIN,
          path: FILTER_PAGE_NEW_ARRIVALS_PATH,
        },
        bestSellers: {
          text: this.$t('best_sellers'),
          domain: WWW_SUBDOMAIN,
          path: FILTER_PAGE_BESTSELLERS_PATH,
        },
        theRoger: {
          text: this.$t('the_roger'),
          domain: WWW_SUBDOMAIN,
          path: ROGER_PATH,
        },
        cyclon: {
          text: this.$t('cyclon'),
          domain: WWW_SUBDOMAIN,
          path: CYCLON_PATH,
        },
        classics: {
          text: this.$t('classics'),
          domain: WWW_SUBDOMAIN,
          path: CLASSICS_PAGE_PATH,
        },
        shoeFinder: {
          text: this.$t('shoe_finder'),
          domain: WWW_SUBDOMAIN,
          path: SHOE_FINDER_PATH,
        },
        giftCards: {
          text: this.$t('gift_cards'),
          domain: WWW_SUBDOMAIN,
          path: PDP_GIFT_CARDS_PATH,
          checkVisibility: () => checkForApacCountry() === false,
        },
        referFriend: {
          text: this.$t('refer_friend'),
          domain: WWW_SUBDOMAIN,
          path: FRIENDBUY_PATH,
        },
      },
    }
  },

  computed: {
    ...mapState('page', ['isSpa']),
  },
}
</script>

<style scoped lang="scss">
@import './footer-settings';

.footer-intro {
  background-color: $c-white;

  &__anchor {
    display: inline-block;
    padding-top: 10px;
    font-size: $font-size-larger;
    font-weight: bold;
    line-height: 1.75;
    color: $c-black;
  }
}
</style>

<i18n src="@/locales/footer_intro.json">
</i18n>
